import React, { useEffect } from 'react';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { useSelector, useDispatch } from 'react-redux';
import { TRootState } from 'redux/reducers/rootReducer';
import { ResetScroll } from 'functions/General';
import RequestStatus from 'types/general/requests/RequestStatus';
import { LargeLoadingIndicator } from 'components/content/shared/other/LoadingIndicator';
import { LargeErrorMessage } from 'components/content/shared/other/ErrorMessage';
import { LibraryDocumentsContainer } from './LibraryDocumentsContainer';
import { fetchLibraryDocuments, initialQueryData } from 'redux/actions/dataActions/library/overview/LibraryDocumentsActions';
import { resetLibraryDocumentsFetchStatus } from 'redux/reducers/data_action_reducers/library/overview/LibraryDocumentsReducer';
// import { InvoicesTable } from './InvoicesTable';

var completedSetup = false;

export function LibraryDocumentsOverViewPage()
{
	const dispatch = useDispatch();
	const thunkDispatch = useThunkDispatch();
	const libraryDocumentsState = useSelector((rootState: TRootState) => rootState.data.libraryDocuments.overview.documents);

	// console.log('combinedRequestStatus', combinedRequestStatus);
	// console.log('invoicesState', invoicesState);

	// Initialization call
	useEffect(() =>
	{
		ResetScroll();

		// Send fetch request
		thunkDispatch(fetchLibraryDocuments(initialQueryData));

		return function cleanup()
		{
			dispatch(resetLibraryDocumentsFetchStatus());
			completedSetup = false;
		}

		// eslint-disable-next-line
	}, []);

	if (libraryDocumentsState.requestStatus === RequestStatus.succes) {
		completedSetup = true;
	}



	return (
		<div className="invoices-overview-page">
			{
				completedSetup &&
				<>
					<h1 className="page-title mgb-5">Your Library</h1>
					<h3 className="page-subtitle mgb-25">A collection of documents concerning our cooperation, like prices, QA documents,…</h3>
					<LibraryDocumentsContainer documentsState={libraryDocumentsState} />
				</>
			}
			{
				!completedSetup &&
				<LargeLoadingIndicator />
			}
			{
				libraryDocumentsState.requestStatus === RequestStatus.error &&
				<LargeErrorMessage />
			}
		</div>
	);
};